export default "__VITE_ASSET__5399b58c__"